import React, {ReactElement, Component, Dispatch, SetStateAction, useContext, useState, useEffect} from 'react';
import {Button, Col, Row, Select, Tooltip} from 'antd';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {http_get, loading_alert, loading_alert_before, loading_alert_after, getPopupNode} from '../common-file/service';
import {PlusOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import SearchInput from "../component/search-input";

// 全局变量
import {ModalVisibleContext} from "../contexts/modal-visible";
import {ServiceNameContext} from '../contexts/service-name-select';
import {DataCenterNameContext} from '../contexts/dataCenter-select';
import {ClusterNameContext} from '../contexts/cluster-select';
import {WorkspaceNameContext} from '../contexts/workspace-select';
import {NamespaceNameContext} from '../contexts/namespace-select';
import {ReloadServiceListContext} from "../contexts/reload-service-list";
import DropdownMenuSubscription from "../../../components/dropdown-menu-subscription/dropdown-menu-subscription";

// data type
import {MessageType} from "antd/lib/message/index";
import {modalType} from "../common-file/interfaceType";

import "../less/service.less";

const BodyTitleCard = (props:any):ReactElement<any, string | (new (props:any)=> Component<any, any, any>)> =>{

    const {card_title, formList, searchPlaceholder, intl} = props,
        {service, dataCenter, cluster, workspace, namespace} = formList.select,
        set_modal_visible: Dispatch<SetStateAction<modalType>> = useContext(ModalVisibleContext)[1],
        [service_name, set_service_name]: [string, Dispatch<SetStateAction<string>>] = useContext(ServiceNameContext),
        [service_name_list, set_service_name_list]= useState([]),
        [dataCenter_name, set_dataCenter_name]: [string, Dispatch<SetStateAction<string>>] = useContext(DataCenterNameContext),
        [dataCenter_name_list, set_dataCenter_name_list] = useState([]),
        [cluster_name, set_cluster_name]: [string, Dispatch<SetStateAction<string>>] = useContext(ClusterNameContext),
        [cluster_name_list, set_cluster_name_list] = useState([]),
        [workspace_name, set_workspace_name]: [string, Dispatch<SetStateAction<string>>] = useContext(WorkspaceNameContext),
        [workspace_name_list, set_workspace_name_list] = useState([]),
        [namespace_name, set_namespace_name]: [string, Dispatch<SetStateAction<string>>] = useContext(NamespaceNameContext),
        [namespace_name_list, set_namespace_name_list] = useState([]),
        [reload_service_list, set_reload_service_list]: [boolean, Dispatch<SetStateAction<boolean>>] = useContext(ReloadServiceListContext),
        path = props.history.location.pathname.substring(1);

    const load_service_list = ()=>{
        (async()=>{
            loading_alert_before();
            const service_list_1:any = await http_get('/serviceHub/v2/publisher/services', props);
            if(service_list_1 && service_list_1.data){
                const {data} = service_list_1,
                    service_name_session: string| null = sessionStorage.getItem('service_name'),
                    service_name_filter: any = data.filter((item:any)=> service_name_session === item),
                    list: any = [];
                set_service_name(service_name_filter.length>0? service_name_filter[0]: '-1');
                // eslint-disable-next-line
                data.map((item:any, key: number)=>{
                    list.push({
                        key: key,
                        name: item
                    })
                });
                set_service_name_list(list);
            }
            loading_alert_after();
        })()
    };

    // 获取service name
    useEffect(()=>{
        if(service_name_list.length<=0 && service){
            load_service_list();
        }
        // eslint-disable-next-line
    },[service_name_list, service]);

    useEffect(()=>{
        if(reload_service_list){
            load_service_list();
            set_reload_service_list(false);
        }
        // eslint-disable-next-line
    }, [reload_service_list]);

    // 获取dataCenter
    useEffect(()=>{
        if(dataCenter_name_list.length<=0 && dataCenter){
            const list: any =['local'];
            set_dataCenter_name(list[0]);
            set_dataCenter_name_list(list);
        }
        // eslint-disable-next-line
    },[service_name_list, dataCenter]);

    // 获取cluster
    useEffect(()=>{
        if(cluster && dataCenter_name){
            (async()=>{
                loading_alert_before();
                const {data} = await http_get(`/v1/datacenter/${dataCenter_name}/clusternames`, props) as any || {};
                let list:any = [];
                if(data?.items){
                    // eslint-disable-next-line
                    data.items.map((item:any)=>{
                        list.push({
                            key: item.name,
                            ...item
                        })
                    })
                }
                set_cluster_name_list(list);
                loading_alert_after();
            })()
        }else {
            set_cluster_name('-1');
            set_cluster_name_list([]);
        }
        // eslint-disable-next-line
    }, [dataCenter_name, cluster]);

    // 获取workspace
    useEffect(()=>{
        if(workspace && cluster_name && cluster_name !== '-1'){
            (async ()=>{
                loading_alert_before();
                const {data} = await http_get(`/v1/datacenter/${dataCenter_name}/cluster/${cluster_name}/workspacenames`, props) as any || {};
                let list:any = [];
                if(data?.items){
                    // eslint-disable-next-line
                    data.items.map((item:any)=>{
                        list.push({
                            key: item.name,
                            ...item
                        })
                    })
                }
                set_workspace_name_list(list);
                loading_alert_after();
            })()
        }else {
            set_workspace_name_list([]);
        }
        set_workspace_name('-1');
        // eslint-disable-next-line
    }, [cluster_name, workspace]);

    // 获取namespace
    useEffect(()=>{
        if(namespace && workspace_name && workspace_name !== '-1'){
            (async ()=>{
                const loading: MessageType = loading_alert('loading namespace...'),
                    {data} = await http_get(`/v1/datacenter/${dataCenter_name}/cluster/${cluster_name}/workspace/${workspace_name}/namespacenames`, props) as any || {};
                let list:any = [];
                if(data?.items){
                    // eslint-disable-next-line
                    data.items.map((item:any)=>{
                        list.push({
                            key: item.name,
                            ...item
                        })
                    })
                }
                set_namespace_name_list(list);
                loading();
            })()
        }else {
            set_namespace_name_list([]);
        }
        set_namespace_name('-1');
        // eslint-disable-next-line
    }, [workspace_name, namespace]);


    const select_change = (type: string, val: any)=>{
        switch (type){
            case 'serviceName': set_service_name(val); sessionStorage.setItem('service_name', val); break;
            case 'dataCenterName': set_dataCenter_name(val); sessionStorage.setItem('dataCenter_name', val); break;
            case 'clusterName': set_cluster_name(val); sessionStorage.setItem('cluster_name', val); break;
            case 'workspaceName': set_workspace_name(val); sessionStorage.setItem('workspace_name', val); break;
            case 'namespaceName': set_namespace_name(val); sessionStorage.setItem('namespace_name', val); break;
            default: break;
        }
    };

    return(
        <div>
            <Row>
                <Col lg={card_title.info ? 10 : 24}>
                    <div className="card_title management-label-line font-size-16">
                        <FormattedMessage id={card_title.name} />
                        <Tooltip placement="rightBottom" title={<FormattedMessage
                            id={card_title.subscription} />}><QuestionCircleOutlined className="autoscale_help" /></Tooltip>
                    </div>
                </Col>
            </Row>
            <div className={`management-select-area`}>
                {card_title.info &&
                    <div className="d-flex flex-end flex-wrap" style={path.includes("instance-list") ? {marginTop: '-8px'} : {marginBottom: '15px', marginTop: '-8px'}} >
                        {card_title.info.map((item: any, key: number) => (
                            <div
                                key={key}
                                className="text-ellipsis pl-30 font-14"
                                title={`${intl.formatMessage({ id: item.key })}: ${item.value}`}
                            >
                                <span className="font-w-6">
                                    <FormattedMessage id={item.key} />
                                    <FormattedMessage id={':'} />
                                </span>
                                {item.value}
                            </div>
                        ))}
                    </div>}
                {
                    formList &&
                    <div style={formList.add ? { position: 'relative', minHeight: '32px' } : {}}>
                        <Row gutter={16} className={`${formList.add ? 'row-has-add' : ''} row-form `}>
                            {
                                path.includes("instance-list") ? 
                                <Col xs={12} sm={8} md={8} lg={6} xxl={5}>
                                    <DropdownMenuSubscription />
                                </Col> : <div/>
                            }
                            {service && service_name_list.length > 0 &&
                                <Col xs={12} sm={8} md={6} lg={4} xxl={3}>
                                    <div className="font-size-14"><FormattedMessage id="service_name" /></div>
                                    <Select
                                        className="w-100"
                                        value={service_name}
                                        onChange={(e: any) => select_change('serviceName', e)}
                                        getPopupContainer={() => getPopupNode()}
                                    >
                                        <Select.Option key={'-1'} value={'-1'}><FormattedMessage id={'all'} /></Select.Option>
                                        {service_name_list.map((option: any) => (
                                            <Select.Option key={option.name} value={option.name}>{option.name}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            }
                            {dataCenter && dataCenter_name_list.length > 0 &&
                                <Col xs={12} sm={8} md={6} lg={4} xxl={3}>
                                    <Select
                                        defaultValue={dataCenter_name}
                                        onChange={(e: any) => select_change('dataCenterName', e)}
                                        getPopupContainer={() => getPopupNode()}
                                    >{dataCenter_name_list.map((option: any) => (
                                        <Select.Option key={option} value={option}>{option}</Select.Option>
                                    ))}</Select>
                                </Col>
                            }
                            {cluster && cluster_name_list.length > 0 &&
                                <Col xs={12} sm={8} md={6} lg={4} xxl={3}>
                                    <Select
                                        defaultValue={'-1'}
                                        onChange={(e: any) => select_change('clusterName', e)}
                                        getPopupContainer={() => getPopupNode()}
                                    >
                                        <Select.Option key={'-1'} value={'-1'}><FormattedMessage id={'please_choose'} /></Select.Option>
                                        {cluster_name_list.map((option: any) => (
                                            <Select.Option key={option.key} value={option.key}>{option.name}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            }
                            {workspace && workspace_name_list.length > 0 &&
                                <Col xs={12} sm={8} md={6} lg={4} xxl={3}>
                                    <Select
                                        value={workspace_name}
                                        onChange={(e: any) => select_change('workspaceName', e)}
                                        getPopupContainer={() => getPopupNode()}
                                    >
                                        <Select.Option key={'-1'} value={'-1'}><FormattedMessage id={'please_choose'} /></Select.Option>
                                        {workspace_name_list.map((option: any) => (
                                            <Select.Option key={option.id} value={option.id}>{option.name}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            }
                            {namespace && namespace_name_list.length > 0 &&
                                <Col xs={12} sm={8} md={6} lg={4} xxl={3}>
                                    <Select
                                        value={namespace_name}
                                        onChange={(e: any) => select_change('namespaceName', e)}
                                        getPopupContainer={() => getPopupNode()}
                                    >
                                        <Select.Option key={'-1'} value={'-1'}><FormattedMessage id={'please_choose'} /></Select.Option>
                                        {namespace_name_list.map((option: any) => (
                                            <Select.Option key={option.key} value={option.key}>{option.name}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            }
                            {formList.input && formList.input.map((list: any) => (
                                <Col key={list.key} className={'padding-right-10'} xs={list.xs} sm={list.sm} md={list.md} lg={list.lg} xxl={list.xxl} style={(path.includes("instance-list") || path.includes("resource/service")) ? {marginTop: "15px"} : {}}>
                                    <SearchInput placeholder={searchPlaceholder} disabled={list.disabled} />
                                </Col>
                            ))}
                        </Row>
                        {formList.add && <Button type="primary" onClick={() => set_modal_visible({ toggle: true, type: 'create' })} style={ (path.includes("instance-list") || path.includes("resource/service")) ? {position: 'absolute', right: 0, top: "15px", height: '40px'} : {position: 'absolute', right: 0, top: "-8px", height: '40px'}}><PlusOutlined /></Button>}
                    </div>
                }
            </div>
        </div>
    )
};

export default injectIntl(withRouter(BodyTitleCard) as any);
